import { render, staticRenderFns } from "./UserCollect.vue?vue&type=template&id=2421646a&"
import script from "./UserCollect.vue?vue&type=script&lang=ts&"
export * from "./UserCollect.vue?vue&type=script&lang=ts&"
import style0 from "./UserCollect.vue?vue&type=style&index=0&lang=less&"
import style1 from "./UserCollect.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports